import {Component, OnInit} from '@angular/core';
import {DatePicked} from '../date-picker-custom/model/date-picked';
import {BaseComponent} from '../../base/base.component';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {
    AdhesionDashboard,
    AreaDashboard,
    CompetenceDashboard,
    CompetencePerformanceAvgRow,
    DashBoardRoutesGQL,
    DashBoardRoutesQuery,
    Evaluation,
    EvaluationOverviewDashboard,
    EvaluationsGQL, EvaluationsQuery, FeedbackLateDashboardPage,
    FeedbackQtdDashboard,
    GetUnitiesGQL,
    GetUnitiesQuery, InputMaybe,
    PdiFollowUpDashboard, Scalars,
    SearchDashboardInput,
    Unity,
    UnityDashboard,
    UserCostCenter, UserCostCenterGQL,
    UserEvaluationDashboard,
} from '../../../generated/graphql';
import moment from 'moment';
import {QueryRef} from 'apollo-angular';

declare var $: any;

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent extends BaseComponent implements OnInit {
    filter: SearchDashboardInput = new SearchDashboardInput();
    evaluationSelected = '';

    evaluationsQuery: QueryRef<EvaluationsQuery>;
    evaluations: Evaluation[] = [];

    unitiesQuery: QueryRef<GetUnitiesQuery>;
    allUnities: Unity[] = [];

    dashBoardRoutesQuery: QueryRef<DashBoardRoutesQuery>;

    userCostCenter: UserCostCenter = new UserCostCenter();
    evaluationOverviewDashboard: EvaluationOverviewDashboard = new EvaluationOverviewDashboard();
    competencePerformanceAverageDashboard: CompetencePerformanceAvgRow[] = [];
    pdiFollowUpDashboard: PdiFollowUpDashboard = new PdiFollowUpDashboard();
    feedbackQtdDashboard: FeedbackQtdDashboard = new FeedbackQtdDashboard();

    areaDashboard: AreaDashboard = new AreaDashboard();
    areaDashboardGraph = [['', 0]];
    areaDashboardColumn: any[] = ['Dia', 'Area'];

    unityDashboard: UnityDashboard = new UnityDashboard();
    unityDashboardGraph = [['', 0]];
    unityDashboardColumn: any[] = ['Dia', 'Unidade'];

    feedbackLateDashboard: FeedbackLateDashboardPage = new FeedbackLateDashboardPage();
    labels: any = {
        // previousLabel: '<--',
        previousLabel: ' ',
        // nextLabel: '-->',
        nextLabel: ' ',
        screenReaderPaginationLabel: 'Pagination',
        screenReaderPageLabel: 'page',
        screenReaderCurrentLabel: `You're on page`
    };

    evaluationOverviewColumn: any[] = ['Status', 'Quantidade'];
    evaluationOverviewGraph = [['', 0]];

    evaluationUnityColumn: any[] = ['Unidade', 'Pendentes', 'Não finalizado', 'Finalizados'];
    evaluationUnityGraph = [['', 0, 0, 0]];
    dashboardPieOptions = {
        backgroundColor: {fill: 'transparent'},
        colors: ['#be2727', '#fa9f0e', '#23be45'],
        legend: {position: 'bottom'},
        pieHole: 0.4,
    };

    pdiFollowUpColumn: any[] = ['Status', 'Quantidade'];
    pdiFollowUpGraph = [['', 0]];


    feedbackColumn: any[] = ['Mês', 'Porcentagem', 'Porcentagem'];
    feedbackGraph = [['', 0, 0]];
    dashboardFeedBackOptions = {
        backgroundColor: {fill: 'transparent'},
        colors: ['#23a3be', '#95c8ae'],
        bar: {groupWidth: '30%'},
        legend: {position: 'none'},
        series: {1: {type: 'line'}}
    };


    dashboardUnityOptions = {
        backgroundColor: {fill: 'transparent'},
        colors: ['#be2727', '#fa9f0e', '#23be45'],
        bar: {groupWidth: '30%'},
        legend: {position: 'none'},
        isStacked: true,
    };


    dashboardOptions = {
        backgroundColor: {fill: 'transparent'},
        legend: {position: 'none'},
    };


    constructor(public router: Router,
                public evaluationsGQL: EvaluationsGQL,
                public getUnitiesGQL: GetUnitiesGQL,
                public userCostCenterGQL: UserCostCenterGQL,
                public dashBoardRoutesGQL: DashBoardRoutesGQL,
                public translate: TranslateService) {
        super(router, translate);
    }

    ngOnInit(): void {
        // this.filter.start = moment().subtract(30, 'days').utc(true).format();
        // DEFINE COMO DATA INICIAL O PRIMEIRO DIA DO ANO
        this.filter.start = moment().startOf('year').utc(true).format();
        this.filter.end = moment().utc(true).format();
        this.getEvaluations();
        this.getAllUnities();
        this.getUserCostCenter();
    }


    getAllUnities() {
        this.unitiesQuery = this.getUnitiesGQL.watch();
        this.unitiesQuery.valueChanges.subscribe(({data}) => {
            this.allUnities = data.unities as Unity[];
        }, error => super.onError(error));
    }

    getUserCostCenter() {
        this.userCostCenterGQL.watch().valueChanges.subscribe(({data}) => {
            this.userCostCenter = data.userCostCenter as UserCostCenter;
        }, error => super.onError(error));
    }

    getEvaluations() {
        this.evaluationsQuery = this.evaluationsGQL.watch();
        this.evaluationsQuery.valueChanges.subscribe(({data}) => {
            this.evaluations = data.evaluations as Evaluation[];
            this.filter.evaluation = this.evaluations[0].id;
            this.evaluationSelected = this.filter.evaluation;
            this.initGraph();
        });
    }

    initGraph() {
        this.dashBoardRoutesQuery = this.dashBoardRoutesGQL.watch({data: this.filter});
        this.dashBoardRoutesQuery.valueChanges.subscribe(({data}) => {
            this.evaluationSelected = this.filter.evaluation;
            this.evaluationOverviewDashboard = data.evaluationOverviewDashboard as EvaluationOverviewDashboard;
            this.competencePerformanceAverageDashboard = data.competencePerformanceAverageDashboard as CompetencePerformanceAvgRow[];
            this.pdiFollowUpDashboard = data.pdiFollowUpDashboard as PdiFollowUpDashboard;
            this.feedbackQtdDashboard = data.feedbackQtdDashboard as FeedbackQtdDashboard;
            this.unityDashboard = data.unityDashboard as UnityDashboard;
            this.areaDashboard = data.areaDashboard as AreaDashboard;
            this.feedbackLateDashboard = data.feedbackLateDashboard as FeedbackLateDashboardPage;
            this.initGraphOverview();
            this.initGraphEvaluationUnity();
            this.initGraphFollowUp();
            this.initGraphFeedback();
            this.initGraphUnity();
            this.initGraphArea();
        }, error => super.onError(error));
    }

    initGraphOverview() {
        if (!this.isNullOrUndefined(this.evaluationOverviewDashboard.overall)) {
            this.evaluationOverviewGraph = [];
            this.evaluationOverviewDashboard.overall.forEach((e) => {
                this.evaluationOverviewGraph.push([e.label, e.count]);
            });
        }
    }

    initGraphEvaluationUnity() {
        if (!this.isNullOrUndefined(this.evaluationOverviewDashboard.byUnity)) {
            this.evaluationUnityGraph = [];
            this.evaluationOverviewDashboard.byUnity.forEach((e) => {
                const item: any[] = [e.unityName];
                e.items.forEach((it) => item.push(it.count));
                this.evaluationUnityGraph.push(item);
            });
        }
    }

    initGraphFollowUp() {
        if (!this.isNullOrUndefined(this.pdiFollowUpDashboard.pdiStatus)) {
            this.pdiFollowUpGraph = [];
            this.pdiFollowUpDashboard.pdiStatus.forEach((e) => {
                this.pdiFollowUpGraph.push([e.label, e.count]);
            });
        }
    }

    initGraphFeedback() {
        if (!this.isNullOrUndefined(this.feedbackQtdDashboard)) {
            this.feedbackGraph = [];
            this.feedbackQtdDashboard.months.forEach((e) => {
                this.feedbackGraph.push([e.monthLabel, e.percent, this.feedbackQtdDashboard.targetLinePercent]);
            });
        }
    }

    initGraphUnity() {
        this.unityDashboardColumn = ['Dia'];
        if (!this.isNullOrUndefined(this.unityDashboard.graph)) {
            this.unityDashboard.graph[0].detail.forEach((e) => {
                this.unityDashboardColumn.push(e.name, {role: 'style'});
            });
            this.unityDashboardGraph = [];
            this.unityDashboard.graph.forEach((graph) => {
                const ArrayGraph: any[] = [graph.month.toString() + '/' + graph.year.toString()];
                graph.detail.forEach((e) => {
                    ArrayGraph.push(e.count, e.color);
                });
                this.unityDashboardGraph.push(ArrayGraph);
            });
        }
    }

    initGraphArea() {
        this.areaDashboardColumn = ['Dia'];
        if (!this.isNullOrUndefined(this.areaDashboard.graph)) {
            this.areaDashboard.graph[0].detail.forEach((e) => {
                this.areaDashboardColumn.push(e.name, {role: 'style'});
            });
            this.areaDashboardGraph = [];
            this.areaDashboard.graph.forEach((graph) => {
                const ArrayGraph: any[] = [graph.month.toString() + '/' + graph.year.toString()];
                graph.detail.forEach((e) => {
                    ArrayGraph.push(e.count, e.color);
                });
                this.areaDashboardGraph.push(ArrayGraph);
            });
        }
    }

    selectedDate(event: DatePicked) {
        this.filter.start = moment(event.start).utc(true).format();
        this.filter.end = moment(event.end).utc(true).format();
    }

    onFilter() {
        this.dashBoardRoutesQuery.refetch({data: this.filter}).then();
    }

    findElevation(evaluation: InputMaybe<Scalars['String']>) {
        const evalua = this.evaluations.find((e) => e.id === evaluation);
        return evalua.name;
    }

    pageChanged(event: number) {
        this.filter.page = event;
        this.dashBoardRoutesQuery.refetch({data: this.filter}).then();
    }
}
